import { RouteRecordRaw } from "vue-router";
import router from ".";

export const publicRoutes: Array<RouteRecordRaw> = [
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@/layouts/NotFoundLayout.vue'),
        beforeEnter: async (to, from, next) => {
            console.log('Not found:', to, from, router.getRoutes());
            next();
        }
    },
    {
        path: '/public/',
        name: 'public-pages',
        component: () => import('@/layouts/PublicLayout.vue'),
        redirect: '/welcome',  // <-- Use absolute path here
        children: [
            {
                path: 'welcome',
                name: 'welcome',
                component: () => import('@/pages/public/WelcomePage.vue'),
            },
            {
                path: 'style-guide',
                name: 'style-guide',
                component: () => import('@/pages/public/StyleGuide.vue'),
            },
            {
                path: 'mobile-signup/:mode?/:key?',
                name: 'mobile-signup',
                component: () => import('@/pages/public/MobileSignupPage.vue'),
            },
            {
                path: 'mobile-documents/:key?',
                name: 'mobile-documents',
                component: () => import('@/pages/drivers/components/DriverMobilePage.vue')
            },
        ],
    },
    {
        path: '/mobile-iframe',
        name: 'mobile-iframe',
        component: () => import('@/layouts/MobileIframeLayout.vue'),
        redirect: '/mobile-iframe/loading',
        children: [
            {
                path: 'loading',
                name: 'mobile-mechanic-loading',
                component: () => import('@/pages/public/MobileIframeLoading.vue'),
            },
            {
                path: 'fleet-event-dashboard/week',
                name: 'fleet-event-dashboard',
                component: () => import('@/pages/fleet-event-dashboard/FleetEventDashboardWeek.vue'),
                meta: {
                    title: 'fleet-event-dashboard',
                },
            },
            {
                path: 'dashboard',
                name: 'dashboard',
                component: () => import('@/pages/dashboard-cards/DashBoardCardsPage.vue'),
                meta: {
                    title: 'dashboard',
                },

            },
        ],
    },
    {
        path: '/mobile-auto-login',
        name: 'mobile-auto-login',
        component: () => import('@/pages/public/MobileAutoLogin.vue'),
    }
]
